<template>
  <div class="license-error-container font">
    <div class="license-error-inner">
      <h1>{{ $t("errors.errorMsg") }} {{ $t("errors.errorMsg2") }}</h1>
      <br />
      <template v-if="isNoServerError">
        <h2>{{ $t("networkComputer.noSrv") }}</h2>
      </template>
      <template v-else>
        <h2>{{ $t("networkComputer.noPlace") }}</h2>
      </template>
      <h3>{{ $t("networkComputer.contact_admin") }}</h3>
      <div
        class="btn"
        v-if="!isNoServerError"
        style="margin: auto;"
        @click="connectAgain"
      >
        {{ $t("networkComputer.connectAgain") }}
      </div>
      <div
        class="btn"
        v-if="!isNoServerError && isServer"
        style="margin: auto;"
        @click="setServerToBoth"
      >
        {{ $t("networkComputer.back_to_srv") }}
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from "@/services/_axios";
export default {
  computed: {
    isNoServerError() {
      if (globalThis.OTZAR_BASIC_INFO.networkStatus == "no_server") return true;
      return false;
    },
    isServer() {
      const isServer = globalThis.OTZAR_BASIC_INFO.networkMode == "both";
      if (isServer) return true;
      return false;
    },
  },
  methods: {
    connectAgain() {
      if (globalThis.ELECTRON_ENV) globalThis.RELOAD_APP();
    },
    async setServerToBoth() {
      await Axios.get("/api/network/set-server-to?mode=server");
      location.href = window.location.protocol + "\\\\" + window.location.host;
    },
  },
};
</script>

<style lang="scss" scoped>
.license-error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: #f7f7f7;
}
h1 {
  margin: 0;
  font-size: 35px;
  font-weight: bolder;
}
h2 {
  font-size: 35px;
  margin-top: 17px;
  font-weight: normal;
}
.error-code {
  color: var(--custom-color1);
  border-top: 1px solid;
  border-bottom: 1px solid;
  display: flex;
  align-items: center;
  width: fit-content;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin: 0 auto 50px auto;
  font-size: 20px;
}
.contact {
  font-size: 16px;
}
</style>
